import React from 'react';
export const epLineColumns = [
    {
        title: 'No',
        dataIndex: 'lineNum',
        key: 'lineNum',
    },
    {
        title: 'doc no',
        dataIndex: 'docNo',
        key: 'docNo',
    },
    {
        title: 'ep code',
        dataIndex: 'epCode',
        key: 'epCode',
    },
    {
        title: 'pc number',
        dataIndex: 'pcNo',
        key: 'pcNo',
    },
    {
        title: 'pc name',
        dataIndex: 'pcName',
        key: 'pcName',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (text) => {
            return <span>{text?.toLocaleString()}</span>
        }
    }
]